module.exports = "/images/loader_logo.svg?d6b31f2b11a36b3807034caefd07b36d";